import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import { Loading } from '../../common';
import { ROUTES } from '../../../utils/constants';

/**
 * Componente para proteger rotas que requerem autenticação
 */
const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Mostra loading enquanto verifica autenticação
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading size="lg" text="Carregando..." />
      </div>
    );
  }

  // Se requer autenticação e não está autenticado
  if (requireAuth && !isAuthenticated) {
    // Redireciona para login, salvando a localização atual
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  // Se não requer autenticação (rota pública) e está autenticado
  if (!requireAuth && isAuthenticated) {
    // Redireciona para dashboard se já estiver logado
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  // Se passou nas verificações, renderiza o conteúdo
  return children;
};

export default ProtectedRoute;